import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import BASE_QUERY from '@/features/baseQuery';

export const tenantConsentApi = createApi({
	reducerPath: 'tenantConsentApi',
	tagTypes: ['TENANT_CONSENT'],
	baseQuery: fetchBaseQuery({
		...BASE_QUERY,
		baseUrl: process.env.REACT_APP_TENANT_CONSENT_ENDPOINT,
	}),
	endpoints: (builder) => ({
		getAdminConsentUrl: builder.query({
			providesTags: ['TENANT_CONSENT'],
			query: () => ({
				url: `/initialise`,
				method: 'POST',
			}),
			transformResponse: (response) => response?.adminConsentUrl,
			transformErrorResponse: (response) => {
				console.log('👾 ~ transform /initialise response', response);
				return response;
			},
		}),
	}),
});

export const { useGetAdminConsentUrlQuery } = tenantConsentApi;
